module.exports = __webpack_public_path__ + "img/dd-phone.509b8d9b.jpg";